import { Box, Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import LoginPaper from '../../components/LoginPaper'

export interface IRecoverySuccessPanelProps {
  email: string
}

const Confirmation = (props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [first, second] = t('login.recovery').split('$#$')

  return (
    <Box display={'flex'} flexDirection={'column'}>
      {first}
      <Typography color={theme.palette.primary.main} fontWeight={600}>{props.email}</Typography>
      {second}
    </Box>
  )
}

const RecoverySuccessPanel = ({ email }: IRecoverySuccessPanelProps) => {
  const { t } = useTranslation()

  return (
    <LoginPaper>
      <Stack alignItems="center" gap={2}>
        <Typography
          sx={{
            fontSize: '24px',
            lineHeight: '36px',
            fontWeight: 600,
            color: 'content.secondary',
            '&::after': {
              bottom: 0,
              color: 'common.accent',
              content: '" !"',
              position: 'relative',
              transform: 'translate(-100%, 0)',
            },
          }}
        >
          {t('login.email_send')}
        </Typography>

        <Box fontSize="48px" sx={{ color: 'common.accent' }}>
          <i className="fa-solid fa-circle-check"></i>
        </Box>

        <Stack
          gap={0.5}
          padding={'0px 80px'}
          sx={{ fontSize: '14px', lineHeight: '24px', fontWeight: 400 }}
        >
          <Typography
            sx={{
              fontSize: 'inherit',
              lineHeight: 'inherit',
              fontWeight: 'inherit',
              textAlign: 'center',
            }}
          >
              <Confirmation email={email} />
          </Typography>
        </Stack>
      </Stack>
    </LoginPaper>
  )
}

export default RecoverySuccessPanel
